/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import { EBasketType } from '@modules/app/appConstants';
import { EBreadCrumbType } from '@modules/breadCrumbs/breadCrumbsTypes';

import { IWizardRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const WizardAdditionalReportsRouteConfiguration: IWizardRouterConfiguration[] = [
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.additionalReports,
        ],
        path: RoutePath.wizardAdditionalReportsFromSubscribers,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.subscriberMobileInfo,
            EBreadCrumbType.additionalReports,
        ],
        path: RoutePath.wizardAdditionalReportsFromSubscriberId,
    },
    {
        basketType: EBasketType.ACCOUNT,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.additionalReports,
        ],
        path: RoutePath.wizardAdditionalReportsFromAccounts,
    },
    {
        basketType: EBasketType.ACCOUNT,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.additionalReports,
        ],
        path: RoutePath.wizardAdditionalReportsFromAccountId,
    },
];
